import { showPendingToastIfAny as showPendingToastIfAnyBase } from '@mathflat/shared/@modules/forceUpdate/postUpdateToast'

import { toastService } from '~/@common/services/toast.service'

export const showPendingToastIfAny = () =>
  showPendingToastIfAnyBase((message) => toastService.success(message))
